













































import CookieLaw from 'vue-cookie-law';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoModal from './Organisms/co-modal/CoModal.vue';

export default {
    name: 'CookieBanner',
    components: {
        CoHeadline,
        CoButton,
        CookieLaw,
        CoModal,
    },
    computed: {
        isMobile() {
            return window.innerWidth <= 768;
        },
        privacyPolicyContent() {
            return this.privacyPolicy?.Content || null;
        },
    },
    props: {
        privacyPolicy: {
            type: Object,
            default: null,
        },
    },
};
